import { render } from "./CardVariant.vue?vue&type=template&id=099cf03e&scoped=true"
import script from "./CardVariant.vue?vue&type=script&lang=js"
export * from "./CardVariant.vue?vue&type=script&lang=js"

import "./CardVariant.vue?vue&type=style&index=0&id=099cf03e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099cf03e"]])

export default __exports__